import styled from 'styled-components';

export const YadoItemView = styled.a`
  cursor: pointer;
  display: block;
  border-radius: 0.25em;
  margin-bottom: 1em;
  text-decoration: none;
  &:hover {
    box-shadow: 0px 4px 10px 0 rgba(53, 118, 172, 0.15);
    text-decoration: none;
  }
  > div:last-of-type {
    border-bottom-left-radius: 0.25em;
    border-bottom-right-radius: 0.25em;
    border-bottom-color: var(--gray600);
    [class^="YadoItemPhotoView"] {
      border-bottom-left-radius: 0.25em;
    }
  }
`;

export const YadoItemTopView = styled.div`
  display: flex;
  border-top-left-radius: 0.25em;
  border-top-right-radius: 0.25em;
  border: 1px solid var(--gray600);
  border-bottom-color: var(--gray300);
`;

export const YadoItemBottomView = styled.div`
  padding: 0.5em;
  border-bottom-left-radius: 0.25em;
  border-bottom-right-radius: 0.25em;
  border: 1px solid var(--gray600);
  border-top: 0;
  .first-resort {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .toggle {
      padding: 0.5em 1em;
      color: var(--gray600);
      border-radius: 0.5em;
      &:hover, &:focus {
        background-color: var(--blue100);
      }
    }
  }
`;
